import moment from 'moment';
import { ReactComponent as EditIcon } from '../../../assets/images/pencil.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import { TankLevelInterface } from '../../../utils/types/tankLevel';
import { MRT_ColumnDef } from 'material-react-table';
import IconButton from '@mui/material/IconButton';
import { UserInterface } from '../../../utils/types/user';

const getTankLevelsGridColumns = (
  onEditTankLevel: (tankLevel: TankLevelInterface) => void,
  onDeleteTankLevel: (tankLevel: TankLevelInterface) => void
): Array<MRT_ColumnDef<TankLevelInterface>> => [
    {
      accessorKey: 'name',
      header: 'Name'
    },
    {
      accessorKey: 'state',
      header: 'State'
    },
    {
      accessorKey: 'creator',
      header: 'Created by',
      Cell: ({ cell }) => {
        const creator = cell.getValue<UserInterface>();

        return (
          <span>
            {creator ? creator.name + ' ' + creator.lastName : ''}
          </span>
        );
      }
    },
    {
      accessorKey: 'operator',
      header: 'Last Updated By',
      Cell: ({ cell }) => {
        const operator = cell.getValue<UserInterface>();

        return (
          <span>
            {operator ? operator.name + ' ' + operator.lastName : ''}
          </span>
        );
      }
    },
    {
      accessorKey: 'updatedAt',
      header: 'Updated at',
      Cell: ({ cell }) => {
        const date = new Date(cell.getValue<string>());
        const humanReadableDate = moment(date).fromNow();

        return <span style={{ color: '#52659B', fontWeight: 500 }}>{humanReadableDate}</span>;
      }
    },
    {
      header: 'Actions',
      enableSorting: false,
      Cell: ({ cell }) => (
        <>
          <IconButton
            color="secondary"
            aria-label="Edit"
            onClick={() => onEditTankLevel(cell.row.original)}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            color="secondary"
            aria-label="Delete"
            onClick={() => onDeleteTankLevel(cell.row.original)}
          >
            <CloseIcon />
          </IconButton>
        </>
      )
    },
  ];

export default getTankLevelsGridColumns;
